module.exports = __webpack_public_path__ + "static/media/zacarias_zambrano.a1048007.webp";